// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color, xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

interface OrderInformationStyles {
    orderGridContainer?: GridContainerProps;
    orderGridItems: GridItemProps;
    orderWrapper?: InjectableCss;
    orderTitle: TypographyProps;
    orderValue?: TypographyProps;
}

// To split items to grid item with 25% width for each element
export const orderWrapperGridItem = css`
    width: 30%;
    > span {
        font-size: 14px;
    }
    ${xScreen("lte", "sm")} {
        width: 50%;
    }
    ${xScreen("lte", "xs")} {
        width: 100%;
    }
`;

export const orderInfoStyles: OrderInformationStyles = {
    orderGridContainer: {
        gap: 10,
        css: css`
            &&&&{
                @media print {
                    width:calc(100% + 50px);
                }
            }
        `
    },
    orderGridItems: {
        width: [12, 6, 6, 3, 3],
        css: css`
            flex-direction: column;
            ${xScreen("lte", "xs")} {
                flex-direction: row;
                & > div {
                    flex-direction: row;
                }
            }
        `,
    },
    orderTitle: {
        weight: "bold",
        variant: "h6",
        css: css`
            margin-bottom: 4px;
            margin-right: 5px;
            white-space: nowrap;
            color: ${color("common.ui11")};
            font-family: "Mulish", sans-serif;
            font-size: 14px;
            font-weight: 800;
            letter-spacing: 0;
            line-height: 18px;
            text-transform: capitalize;
            &:after {
                content: ":";
            }
        `,
    },
    orderValue: {
        css: css`
            font-size: 14px;
            line-height: 22px;`
    },
    orderWrapper: {
        css: css`
            width: 25%;
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
            ${xScreen("lte", "md")} {
                width: 50%;
            }
            ${xScreen("lt", "sm")} {
                width: 100%;
            }
            @media print {
                width: 50%;
                    display: block;
            }
        `,
    },
};
